import { ContainerModule } from 'inversify';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DIUploadTypes } from '@/dataroom/app/DI/FileUpload/types';
import MultipartFileUploadDispatcherFactory from '@/dataroom/app/DI/FileUpload/MultipartFileUploadDispatcher/index';
import type {
  IMultipartFileUploadDispatcherFactory,
  IMultipartFileUploadDispatcherFactoryMethod,
} from '@/dataroom/app/DI/FileUpload/MultipartFileUploadDispatcher/interfaces';
import SocketProcessingAdapterFactory from '@/dataroom/app/DI/FileUpload/MultipartFileUploadDispatcher/SocketProcessingAdapter/index';
import type {
  ISocketProcessingAdapterFactory,
  ISocketProcessingAdapterFactoryMethod,
} from '@/dataroom/app/DI/FileUpload/MultipartFileUploadDispatcher/SocketProcessingAdapter/interfaces';

export const MultipartFileUploadModule = new ContainerModule(({ bind }) => {
  bind<IMultipartFileUploadDispatcherFactory>(DIUploadTypes.MultipartFileUploadDispatcherFactory)
    .to(MultipartFileUploadDispatcherFactory)
    .inSingletonScope();

  bind<IMultipartFileUploadDispatcherFactoryMethod>(DIUploadTypes.MultipartFileUploadDispatcher)
    .toFactory(({ get }) =>
      (tenantCode?: DataroomTenant) =>
        get<IMultipartFileUploadDispatcherFactory>(DIUploadTypes.MultipartFileUploadDispatcherFactory)
        .create(tenantCode),
    );

  bind<ISocketProcessingAdapterFactory>(DIUploadTypes.SocketProcessingAdapterFactory)
    .to(SocketProcessingAdapterFactory)
    .inSingletonScope();

  bind<ISocketProcessingAdapterFactoryMethod>(DIUploadTypes.SocketProcessingAdapter)
    .toFactory(({ get }) =>
      (tenantCode: DataroomTenant) =>
        get<ISocketProcessingAdapterFactory>(DIUploadTypes.SocketProcessingAdapterFactory)
        .create(tenantCode),
    );
});
